import accordionContent from './accordion-content';
import contentNavigation from './content-navigation';
import navTabsSelection from './nav-tabs-selection';
import productGallery from './product-gallery';
import stickyTabBar from './sticky-tab-bar';
import tabPanelController from './tab-panel-controller';
import tradeIn from './trade-in';
import crossBar from './cross-bar';
import pdpFilter from './pdp-filter';
import feefoScript from './feefo-script';

accordionContent();
contentNavigation();
navTabsSelection();
productGallery();
stickyTabBar();
tabPanelController();
tradeIn();
crossBar();
pdpFilter();
feefoScript();
